import { createFileRoute, Link } from '@tanstack/react-router';

import { ForgotPasswordForm } from '@/features/auth/components/ForgotPasswordForm';
import { PageTransition } from '@/shared/motion';

export const Route = createFileRoute('/_auth/admin/forgot-password')({
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  return (
    <PageTransition className="flex flex-col gap-6">
      <ForgotPasswordForm />
      <p className="text-center text-xs text-foreground-subtle">
        <Link to="/admin/login" className="font-medium text-foreground-muted underline">
          Back to sign in
        </Link>
      </p>
    </PageTransition>
  );
}
